import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslationService } from '@sdbn/common';
import { PauseTransportService } from '../../service/pause-transport.service';
import { ResponseStatus } from '@sdbn/appclient';
import { ResponseMessage } from '@sdbn/appclient';

export interface EndTransportPauseDialogData {
  transportId: number;
  carrier: string;
  name: string;
  identifier: string;
  transportScope: any;
  successCallback: () => void;
}

@Component({
  selector: 'app-end-transport-pause-dialog',
  templateUrl: './end-transport-pause-dialog.component.html',
  styleUrls: ['./end-transport-pause-dialog.component.scss' ]
})
export class EndTransportPauseDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EndTransportPauseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EndTransportPauseDialogData,
    private pauseTransportService: PauseTransportService,
    public translationService: TranslationService) { }

  responseMessages: ResponseMessage[];

  ngOnInit() { }

  confirm() {
    this.pauseTransportService.endPause({
      end: new Date(),
      transport: { id: this.data.transportId }
    }).subscribe(response => {
      if (response.status === ResponseStatus.SUCCESS) {
        this.data.successCallback();
        this.dialogRef.close();
      } else {
        this.responseMessages = response.responseMessages;
      }
    }, error => {
      console.error(error);
    });
  }

}
